export enum WebMetricsEvent {
  PAGE_CHANGE = 'pageChange',
  ERROR = 'error',
  LINK_CLICK = 'linkClick'
}

export enum PageName {
  OVERVIEW = 'seamless-enrollment-checklist-page',
  CUSTOMER_IDENTIFICATION = 'seamless-enrollment-customer-info-page',
  EXISTING_ACCOUNT_ERROR = 'seamless-enrollment-account-already-exits',
  PHONE_NUMBER_LIST = 'seamless-enrollment-confirm-your-number',
  ACCOUNT_NUMBER_POPUP = 'seamless-enrollment-pop-up-primary-policy-holder',
  NOT_FOUND_PRIMARY_POLICY_HOLDER_ERROR = 'seamless-enrollment-no-match-found-primary-policy-holder',
  NOT_FOUND_SECONDARY_POLICY_HOLDER_ERROR = 'seamless-enrollment-no-match-found-secondary-policy-holder', // 'DipRegistrationPhoneNumberModalComponent', // no omniture tag available - using class name
  SESSION_EXPIRED = 'seamless-enrollment-session-expired',
  APPLICATION_ERROR = 'seamless-enrollment-internal-server-error',
  TECHNICAL_ERROR = 'seamless-enrollment-technical-server-error',
  FUNCTIONAL_ERROR = 'seamless-enrollment-functional-server-error',
  PAGE_NOT_FOUND = 'seamless-enrollment-404'
}

export enum ProcessStatus {
  START = 'start',
  COMPLETE = 'complete'
}

export enum ProcessName {
  ENROLLMENT_FLOW = 'seamless-enrollment-flow'
}
export enum LinkType {
  BUTTON = 'button'
}

export interface WebMetricsData {
  event: WebMetricsEvent;
  page?: {
    name?: PageName | string;
    entryPoint?: string;
  };
  site?: {
    language?: string;
    province?: string;
    version?: string;
    environment?: string;
  };
  process?: {
    name?: string;
    status?: ProcessStatus;
  };
  user?: {
    custID?: string;
  };
  link?: {
    name?: string;
    type?: LinkType;
  };
  error?: {
    code?: string;
    message?: string;
  };
  [key: string]: any; // Allow additional dynamic fields
}
